// extracted by mini-css-extract-plugin
export default {"addLabelButton":"LabelSelect_addLabelButton__YR3OR"};